import { axiosInstance } from '../services/axiosInstance';
import catchAsync from '../utils/catchAsync';

export const authLogin = catchAsync(async (body) => {
  const data = axiosInstance.post(
    // `/api/method/login?usr=${body.email}&pwd=${body.password}`
    // `/api/method/technoerp.services.login`,
    `/api/method/technoerp.services.login`,
    body
  );
  console.log(data, 'data-login');
  return data;
});

// export const authForgotPassword = catchAsync(async (body) => {
//   console.log(body);
//   const { data } = await axiosInstance.post(
//     `/api/method/login?usr=${body.email}&pwd=${body.password}`,
//     body
//   );
//   return data;
// });

// export const addPushToken = catchAsync(async body => {
//   const { data } = await axiosInstance.post('/PushTokens', body);
//   return data;
// });

// export const getNotificationsList = catchAsync(async () => {
//   const { data } = await axiosInstance.get('/Notifications');
//   return data;
// });
